import script from "./SfxDialogListWorkOrderSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./SfxDialogListWorkOrderSelect.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QToolbarTitle,QToolbar});
